//@ts-nocheck
import React, { useEffect } from 'react';
import { useSelector } from "react-redux";
import styled from "styled-components";
import * as d3 from 'd3';
import d3tip from 'd3-tip'
import { schemeCategory10 } from 'd3-scale-chromatic';
import * as Helpers from '../../Common/Helpers';
import { Heading3 } from '../../Common/SharedStyledComponents';
import withParentSize from "@visx/responsive/lib/enhancers/withParentSizeModern";

const Earnings = ({ statecode, employeeTypes, industries, title, parentWidth, parentHeight, state, props }) => {

    const EmployeeBoxPlot = useSelector(state => state.newEmployeeReportProperties.EmployeeBoxPlot);

    useEffect(() => {
        const industryGroups = industries.filter(i => i.selected).map(i => i.type);
        const employeeTypeGroups = employeeTypes.filter(e => e.selected).map(e => e.type);
        const filteredData = EmployeeBoxPlot.filter(x => +x.statecode == statecode
            && employeeTypeGroups.includes(x.employee)
            && industryGroups.includes(x.industry));

        const maxCount = Math.max(...filteredData.map(d => d.upper));

        var margin = { top: 25, right: 140, bottom: 60, left: 100 },
            width = (900) - margin.left - margin.right,
            height = 350 - margin.top - margin.bottom;

        d3.select("#EarningsChart svg").remove();
        if (filteredData.length > 0) {

            // append the svg object to the body of the page
            var svg = d3.select("#EarningsChart")
                .append("svg")
                .attr("width", width + margin.left + margin.right)
                .attr("height", height + margin.top + margin.bottom)
                .append("g")
                .attr("transform",
                    "translate(105," + margin.top + ")");

            // Add X axis
            var x = d3
                .scaleBand()
                .domain(industryGroups)
                .range([0, width])
                .padding([0.2]);

            svg.append("g")
                .attr("transform", "translate(0," + height + ")")
                .classed('tick_style', true)
                .call(d3.axisBottom(x).tickSize(0).tickPadding(10));

            // Add Y axis
            var y = d3.scaleLinear()
                .domain([0, maxCount])
                .range([height, 0]);

            svg.append("g")
                .classed('tick_style', true)
                .call(d3.axisLeft(y).tickSizeOuter(0).tickFormat(x => `$${(x.toLocaleString())}`));

            // Another scale for subgroup position?
            var xSubgroup = d3.scaleBand()
                .domain(employeeTypeGroups)
                .range([0, x.bandwidth()])
                .padding([0.05])

            // color palette = one color per subgroup
            var color = d3.scaleOrdinal()
                .domain(["Undergraduate", "Graduate Student", "Postdoc", "Staff", "Faculty", "Other Student"])
                .range(schemeCategory10)

            const chartContainer = document.getElementById("chartEarnings");
            d3.select("#chartEarnings .er_tooltip").remove();
            var tooltipEarnings = d3.select("#chartEarnings").append("div")
                .attr("class", "er_tooltip")
                .style("opacity", 0);

            const showEarningsTooltip = (event, dataValue) => {
                if (!dataValue?.value) return;
                const [px, py] = d3.pointer(event, chartContainer);
                const tooltipHtml = `95th: $${(dataValue.value.upper.toLocaleString())}<br/>75th: $${dataValue.value.q3.toLocaleString()}<br/>Median: $${dataValue.value.median.toLocaleString()}<br/>25th: $${dataValue.value.q1.toLocaleString()}<br/>5th: $${dataValue.value.lower.toLocaleString()}`

                tooltipEarnings.style("opacity", .9);
                tooltipEarnings.html(tooltipHtml)
                    .style("left", (px + 10) + "px")
                    .style("top", (py + 10) + "px");
            };

            const hideEarningsTooltip = () => {
                tooltipEarnings.style("opacity", 0);
            };

            const boxPlotSeriesData = function (d) {
                return employeeTypeGroups.map(function (key) {
                    return { key: key, value: filteredData.find(i => i.industry == d && i.employee == key) };
                });
            };

            // Show the whiskers
            svg.append("g")
                .selectAll("g")
                // Enter in data = loop group per group
                .data(industryGroups)
                .enter()
                .append("g")
                .attr("transform", d => "translate(" + x(d) + ",0)")
                .selectAll("rect")
                .data(boxPlotSeriesData)
                .enter().append("line")
                .attr("x1", d => xSubgroup(d.key))
                .attr("x2", d => xSubgroup(d.key))
                .attr("y1", d => (d.value != undefined) ? y(d.value.lower) : y(0))
                .attr("y2", d => (d.value != undefined) ? y(d.value.upper) : y(0))
                .attr("stroke", d => color(d.key))
                .style("width", xSubgroup.bandwidth())
                .style("pointer-events", "none")

            // rectangle for the main box
            var boxWidth = 15
            svg.append("g")
                .selectAll("g")
                // Enter in data = loop group per group
                .data(industryGroups)
                .enter()
                .append("g")
                .attr("transform", d => "translate(" + x(d) + ",0)")
                .selectAll("rect")
                .data(boxPlotSeriesData)
                .enter().append("rect")
                .attr("x", d => (xSubgroup(d.key) - boxWidth / 2))
                .attr("y", d => (d.value != undefined) ? y(d.value.q3) : y(0))
                .attr("height", d => (d.value != undefined) ? (y(d.value.q1) - y(d.value.q3)) : 0)
                .attr("width", boxWidth)
                .attr("stroke", "black")
                .style("fill", d => color(d.key))
                .style("pointer-events", "none")
            // Show the median
            svg.append("g")
                .selectAll("g")
                // Enter in data = loop group per group
                .data(industryGroups)
                .enter()
                .append("g")
                .attr("transform", d => "translate(" + x(d) + ",0)")
                .selectAll("rect")
                .data(boxPlotSeriesData)
                .enter().append("line")
                .attr("x1", d => (xSubgroup(d.key) - boxWidth / 2))
                .attr("x2", d => (xSubgroup(d.key) + boxWidth / 2))
                .attr("y1", d => (d.value != undefined) ? y(d.value.median) : y(0))
                .attr("y2", d => (d.value != undefined) ? y(d.value.median) : y(0))
                .attr("stroke", "black")
                .style("width", 80)
                .style("pointer-events", "none")

            // Invisible hit target per box-and-whisker: box width, whisker height
            svg.append("g")
                .attr("class", "boxplot-hit-targets")
                .selectAll("g")
                .data(industryGroups)
                .enter()
                .append("g")
                .attr("transform", d => "translate(" + x(d) + ",0)")
                .selectAll("rect")
                .data(boxPlotSeriesData)
                .enter().append("rect")
                .attr("x", d => (xSubgroup(d.key) - boxWidth / 2))
                .attr("y", d => (d.value != undefined) ? y(d.value.upper) : y(0))
                .attr("height", d => (d.value != undefined) ? (y(d.value.lower) - y(d.value.upper)) : 0)
                .attr("width", boxWidth)
                .attr("fill", "transparent")
                .style("cursor", "pointer")
                .on("mouseover", (event, d) => showEarningsTooltip(event, d))
                .on("mousemove", (event, d) => showEarningsTooltip(event, d))
                .on("mouseout", hideEarningsTooltip)

            //Add Axis Labels
            svg.append("text")
                .attr("text-anchor", "end")
                .attr("x", width/2)
                .attr("y", height + margin.top + 30)
                .attr("stroke", "#1d2951")
                .attr("stroke-width", "0.1")
                .classed('axis_style', true)
                .text("Industry Name");

            svg.append("text")
                .attr("text-anchor", "end")
                .attr("transform", "rotate(-90)")
                .attr("y", -margin.left + 15)
                .attr("x", -margin.top - 50)
                .attr("stroke", "#1d2951")
                .attr("stroke-width", "0.1")
                .classed('axis_style', true)
                .text("Earnings")

            //Add Legend
            // Add one dot in the legend for each name.
            var size = 20
            svg.selectAll("mydots")
                .data(employeeTypeGroups)
                .enter()
                .append("rect")
                .attr("x", width - 10)
                .attr("y", function (d, i) { return (-10) + i * (size + 5) }) // 100 is where the first dot appears. 25 is the distance between dots
                .attr("width", size)
                .attr("height", size)
                .style("fill", function (d) { return color(d) })

            // Add one dot in the legend for each name.
            svg.selectAll("mylabels")
                .data(employeeTypeGroups)
                .enter()
                .append("text")
                .attr("x", (width - 10) + size * 1.2)
                .attr("y", function (d, i) { return (-10) + i * (size + 5) + (size / 2) }) // 100 is where the first dot appears. 25 is the distance between dots
                .style("fill", function (d) { return color(d) })
                .text(function (d) { return d })
                .attr("text-anchor", "left")
                .style("alignment-baseline", "middle")
        }

    }, [statecode, employeeTypes, industries, parentWidth])



    return (
        <ChartEarningsRoot id="chartEarnings" className="ChartComponent">
            <TitleDiv>
                <Heading3 center bold>{title}</Heading3>
            </TitleDiv>
            <div id="EarningsChart"></div>
        </ChartEarningsRoot>
    );
}

/**
 * Positioned root so the earnings tooltip anchors to the chart, not the page.
 * */
export const ChartEarningsRoot = styled.div`
    position: relative;
`;

/**
 * Styled div to shrink graph titles
 * */
export const TitleDiv = styled.div`
    width: 75%;
    margin-inline: auto;
`;

export default Earnings;